<h2 mat-dialog-title>Sync to Zoho</h2>
<mat-dialog-content>
  <p>{{ data.pendingCount }} {{ data.pendingCount === 1 ? 'entry' : 'entries' }} will be synced to Zoho Books. Do you want to continue?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
</mat-dialog-actions>
